import type { ReactNode } from 'react'

export function CrmDataTable({ children }: { children: ReactNode }) {
  return (
    <div className='glass-card overflow-hidden p-0'>
      <div className='overflow-x-auto'>{children}</div>
    </div>
  )
}

export function crmTableHeadClass() {
  return 'border-b border-white/[0.06] text-left text-[11px] font-medium uppercase tracking-wider text-text-muted'
}

export function crmTableRowClass(isSelected: boolean) {
  return [
    'cursor-pointer border-b border-white/[0.06] transition-colors hover:bg-white/[0.02]',
    isSelected ? 'bg-white/[0.04]' : '',
  ]
    .filter(Boolean)
    .join(' ')
}
